import { Injectable, inject } from '@angular/core';
import { Store } from '@ngrx/store';

@Injectable({
  providedIn: 'root',
})
export class VideoFacade {
  private readonly store: Store = inject(Store);
}
